// extracted by css-extract-rspack-plugin
export default {"Loading":"styles-module__Loading"};